/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import palette from '@telus-uds/palette-allium/build/web/palette';
import { Box, Text } from '../../design/css';

const DefectComments = ({ data, isAdmin }) => {
  return (
    <>
      {data.map((comment, index) => {
        const {
          text,
          is_admin_only: isAdminOnly,
          updatedAt,
          commenter_name: userName,
          commenter_role_id: roleId
        } = comment;

        const commentDate = moment(updatedAt).format(
          'dddd, MMMM Do YYYY, h:mm:ss a'
        );
        const key = `comment${index}`;
        const isAddedByAdmin = roleId === 1;
        const adminLabel = <span>{isAdminOnly ? '[Admins only]' : ''}</span>;
        const getAdmin = () => {
          return (
            <span>
              {userName}
              {'  '}
              <span>
                <span style={{ color: '#2B8000' }}>
                  {adminLabel}
                  {'  '}
                </span>{' '}
                -{' '}
              </span>
            </span>
          );
        };
        return (
          <>
            {!isAdmin && isAdminOnly
              ? null
              : text && (
                  <Box key={key} top={4}>
                    <Text bold color={palette.color.purpleTelus}>
                      {isAddedByAdmin
                        ? isAdmin
                          ? getAdmin()
                          : 'Support - '
                        : `${userName} - `}
                    </Text>
                    <Text fontWeight="500">{`${text} - `}</Text>
                    <Text bold color={palette.color.greenAccessible}>
                      {commentDate}
                    </Text>
                  </Box>
                )}
          </>
        );
      })}
    </>
  );
};

DefectComments.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      createdAt: PropTypes.string,
      user: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string
      })
    })
  ).isRequired,
  isAdmin: PropTypes.bool.isRequired
};

export default DefectComments;
